// The code in this file will load on every page of your site
//<script id='pixel-script-poptin' src='https://cdn.popt.in/pixel.js?id=cef57f397881f' async='true'></script> 
$w.onReady(function () {
	// Write your code here
});